import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import LeadService from "../../services/LeadService";
import $ from "jquery";
import "datatables.net";
import RegisterUserService from "../../services/RegisterUserService";
import AuthService from "../../services/AuthService";
import {
  FaFileImport,
  FaRedoAlt,
  FaUserAlt,
  FaUsers,
  FaPlus,
} from "react-icons/fa";
import ToastService from "../../services/ToastService";
const API_URL = process.env.REACT_APP_API_URL;

const LEAD_AVATAR_PALETTE = [
  "linear-gradient(135deg,#6366f1,#4f46e5)",
  "linear-gradient(135deg,#06b6d4,#0891b2)",
  "linear-gradient(135deg,#22c55e,#15803d)",
  "linear-gradient(135deg,#f59e0b,#d97706)",
  "linear-gradient(135deg,#ec4899,#be185d)",
  "linear-gradient(135deg,#8b5cf6,#6d28d9)",
];
const escapeHtml = (s) =>
  String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
const leadInitial = (name = "") =>
  (String(name).trim()[0] || "?").toUpperCase();
const leadColor = (seed = "") => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++)
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return LEAD_AVATAR_PALETTE[hash % LEAD_AVATAR_PALETTE.length];
};
const formatDateShort = (raw) => {
  if (!raw) return "—";
  const d = new Date(raw);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString();
};

/** API may use PascalCase and/or System.Text.Json ReferenceHandler.Preserve ($values). */
const unwrapJsonArray = (val) => {
  if (val == null) return [];
  if (Array.isArray(val)) return val;
  if (Array.isArray(val.$values)) return val.$values;
  return [];
};

const normalizeLeadRow = (row) => {
  if (!row || typeof row !== "object") return row;
  return {
    id: row.id ?? row.Id,
    firstName: row.firstName ?? row.FirstName,
    lastName: row.lastName ?? row.LastName,
    email: row.email ?? row.Email,
    contactNumber: row.contactNumber ?? row.ContactNumber,
    address: row.address ?? row.Address,
    property: row.property ?? row.Property,
    source: row.source ?? row.Source,
    sourceTypeId: row.sourceTypeId ?? row.SourceTypeId,
    userId: row.userId ?? row.UserId,
    clientId: row.clientId ?? row.ClientId,
    startDate: row.startDate ?? row.StartDate,
    endDate: row.endDate ?? row.EndDate,
    isLeadAssigned: !!(row.isLeadAssigned ?? row.IsLeadAssigned),
    leadCode: row.leadCode ?? row.LeadCode,
  };
};

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Leads() {
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [employees, setselectedUser] = useState([]);
  const queryParam = useQuery();
  const [selectedValue, setSelectedValue] = useState("");
  const [UserId] = useState(() => AuthService.resolveScopedUserId(queryParam.get("id")));
  const ClientId = AuthService.getLoggedInClientId();
  const tableRef = useRef(null);
  const [leads, setLeads] = useState([]);

  const navigate = useNavigate();
  const [isEmployeeSelectedError, setIsEmployeeSelectedError] = useState(false);

  const toast = useRef(null);
  const toastService = new ToastService(toast);
  const userRole = AuthService.getLoggedInRoleId();

  const currentDate = new Date();
  const formattedCurrentDate = currentDate.toISOString().split("T")[0];
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const formattedStartOfMonth = startOfMonth.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(formattedCurrentDate);
  const [endDate, setEndDate] = useState(formattedCurrentDate);

  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0];
  const savedPageNumber = localStorage.getItem("currentPageNumber")
    ? parseInt(localStorage.getItem("currentPageNumber"))
    : 1;
  const [pageNumber, setPageNumber] = useState(savedPageNumber);
  const pageSize = 10;

  const [recordsTotal, setRecordsTotal] = useState(0);
  const [recordsFiltered, setRecordsFiltered] = useState(0);
  async function fetchLeads() {
    try {
      // const leadsData = await LeadService.getAllLeads(UserId,pageNumber,pageSize);
      //to sort data in descndng order
      // const sortedLeads = leadsData.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
      // setLeads(sortedLeads);
      //setLeads(leadsData);
    } catch (error) {
      console.error("Error fetching leads:", error);
      toastService.showError("Error", "Failed to fetch leads data");
    }
  }

  async function fetchEmployee() {
    try {
      const users = await RegisterUserService.getEmployessByRoleId(4);
      setselectedUser(users);
    } catch (error) {
      console.error("Error fetching employees:", error);
      toastService.showError("Error", "Failed to fetch employees data");
    }
  }

  useEffect(() => {
    fetchEmployee();
  }, [UserId]);

  const handleCheckboxChange = (leadId) => {
    const updatedSelectedRows = new Set(selectedRows);

    if (updatedSelectedRows.has(leadId)) {
      updatedSelectedRows.delete(leadId);
    } else {
      updatedSelectedRows.add(leadId);
    }

    setSelectedRows(updatedSelectedRows);
  };

  useEffect(() => {
    const token = AuthService.getToken();
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      displayStart: (savedPageNumber - 1) * pageSize,
      ajax: function (data, callback, settings) {
        const currentPage = Math.floor(data.start / data.length) + 1;
        localStorage.setItem("currentPageNumber", currentPage);
        setPageNumber(currentPage); // optional: in case you use it in UI
        const url = `${API_URL}/Lead/GetAllLeadsByClientId/${UserId}/${ClientId}/${currentPage}/${pageSize}`;

        $.ajax({
          url,
          type: "POST",
          dataType: "json",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          success: function (response) {
            // ReferenceHandler.Preserve serialises the full ObjectResult,
            // so the real payload sits inside response.value.
            const envelope = response.value ?? response;
            const rawPayload = envelope.data ?? envelope.Data;
            const dataArr = unwrapJsonArray(rawPayload).map(normalizeLeadRow);
            callback({
              draw: parseInt(data.draw, 10),
              recordsTotal:
                envelope.recordsTotal ?? envelope.RecordsTotal ?? 0,
              recordsFiltered:
                envelope.recordsFiltered ?? envelope.RecordsFiltered ?? 0,
              data: dataArr,
            });
          },
          error: function (xhr, error, code) {
            console.error("API Request failed:", error, xhr);
            toastService.showError("Error", "Failed to fetch leads data");
          },
        });
      },
      columnDefs: [{ targets: [0], visible: true, searchable: false }],
      columns: [
        {
          data: "id",
          name: "Select",
          render: function (data, type, row) {
            const isChecked = selectedRows.has(row.id);
            const isDisabled = row.isLeadAssigned;
            return `<input type="checkbox" class="row-checkbox" data-row="${row.id}" ${isDisabled ? "disabled" : ""} ${isChecked ? "checked" : ""} /> `;
          },
          orderable: false,
          searchable: false,
        },
        {
          data: "leadCode",
          name: "Lead Code",
          autoWidth: true,
          render: function (data) {
            return `<span class="lead-code-pill">${escapeHtml(data || "—")}</span>`;
          },
        },
        {
          data: "firstName",
          name: "First Name",
          autoWidth: true,
          render: function (data, type, row) {
            const fullName =
              [row.firstName, row.lastName].filter(Boolean).join(" ") ||
              "Unknown";
            const seed = `${row.firstName || ""}${row.lastName || ""}${row.email || ""}`;
            return `
              <div class="user-cell">
                <span class="user-avatar" style="background:${leadColor(seed)}">${escapeHtml(leadInitial(row.firstName))}</span>
                <span class="user-cell-meta">
                  <span class="user-cell-name">${escapeHtml(fullName)}</span>
                </span>
              </div>`;
          },
        },
        {
          data: "email",
          name: "Email",
          autoWidth: true,
          render: function (data) {
            if (!data) return `<span class="cell-muted">—</span>`;
            const safe = escapeHtml(data);
            return `<a href="mailto:${safe}" class="cell-strong" style="text-decoration:none">${safe}</a>`;
          },
        },
        {
          data: "contactNumber",
          name: "Mobile",
          autoWidth: true,
          render: function (data) {
            if (!data) return `<span class="cell-muted">—</span>`;
            const safe = escapeHtml(data);
            return `<a href="tel:${safe}" class="cell-strong" style="text-decoration:none; color:var(--app-primary-700)">${safe}</a>`;
          },
        },
        {
          data: "address",
          name: "Address",
          autoWidth: true,
          render: function (data) {
            return `<span class="cell-muted">${escapeHtml(data || "—")}</span>`;
          },
        },
        {
          data: "property",
          name: "Property",
          autoWidth: true,
          render: function (data) {
            if (!data) return `<span class="cell-muted">—</span>`;
            const safe = escapeHtml(data);
            return `<span class="property-pill" title="${safe}">${safe}</span>`;
          },
        },
        {
          data: "source",
          name: "Source",
          autoWidth: true,
          render: function (data) {
            if (data === "fb") {
              return `<span class="source-chip fb" title="Facebook"><i class="fab fa-facebook-f"></i></span>`;
            } else if (data === "ig") {
              return `<span class="source-chip ig" title="Instagram"><i class="fab fa-instagram"></i></span>`;
            } else if (data) {
              return `<span class="source-text">${escapeHtml(data)}</span>`;
            }
            return `<span class="cell-muted">—</span>`;
          },
        },
        {
          data: "startDate",
          name: "Start Date",
          autoWidth: true,
          render: function (data) {
            return `<span class="date-chip">${escapeHtml(formatDateShort(data))}</span>`;
          },
        },
        {
          data: "endDate",
          name: "End Date",
          autoWidth: true,
          render: function (data) {
            return `<span class="date-chip">${escapeHtml(formatDateShort(data))}</span>`;
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            return `
              <button class="action-btn edit-lead-btn" data-id="${row.id}" title="Edit">
                <i class="pi pi-pencil"></i>
              </button>
            `;
          },
          orderable: false,
          searchable: false,
        },
      ],
      drawCallback: function (settings) {
        $(tableRef.current)
          .find(".row-checkbox")
          .each(function () {
            const rowId = $(this).data("row");
            if (selectedRows.has(rowId)) {
              $(this).prop("checked", true);
            } else {
              $(this).prop("checked", false);
            }
          });
      },
      stateSave: true,
    });

    $(tableRef.current).on("change", ".row-checkbox", function () {
      const rowId = $(this).data("row");
      setSelectedRows((prev) => {
        const newSet = new Set(prev);
        if ($(this).is(":checked")) {
          newSet.add(rowId);
        } else {
          newSet.delete(rowId);
        }
        return newSet;
      });
    });

    $(tableRef.current).on("click", ".edit-lead-btn", function () {
      const leadId = $(this).data("id");
      navigate(`/editlead/${leadId}`);
    });

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [UserId, ClientId]);

  const handleDateChange = (event) => {
    const value = event.target.value;
    const today = formattedCurrentDate;

    if (value === "today") {
      setStartDate(today);
      setEndDate(today);
    } else if (value === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const formattedYesterday = yesterday.toISOString().split("T")[0];
      setStartDate(formattedYesterday);
      setEndDate(formattedYesterday);
    } else if (value === "last10days") {
      setStartDate(formattedTenDaysAgo);
      setEndDate(today);
    } else if (value === "thisMonth") {
      setStartDate(formattedStartOfMonth);
      setEndDate(today);
    }
  };

  const handleChange = (event) => {
    setSelectedValue(event);
    if (event) {
      setIsEmployeeSelectedError(false);
    }
  };

  const sourceTypes = [
    { id: 1, name: "Facebook" },
    { id: 2, name: "Instagram" },
    { id: 3, name: "Reference" },
  ];

  const AssignLead = async () => {
    setIsEmployeeSelectedError(!selectedValue);

    if (selectedRows.size === 0) {
      toastService.showError("Error", "Please select at least one lead");
      return;
    }

    if (!selectedValue) {
      toastService.showError("Validation Error", "Please select an employee.");
      return;
    }

    try {
      await LeadService.AssignedLeadsToEmployee(
        selectedValue,
        Array.from(selectedRows),
      );
      toastService.showSuccess("Success", "Leads assigned successfully");
      setSelectedValue("");
      setSelectedRows(new Set());
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        const table = $(tableRef.current).DataTable();
        table.ajax.reload(null, false); // This will reload the data and preserve the current page (false means do not reset to page 1)
      }
    } catch (error) {
      toastService.showError("Error", "Failed to assign leads");
    }
  };

  function getStatusClass(sourceTypeName) {
    switch (sourceTypeName) {
      case "Facebook":
        return "table-warning";
      case "Instagram":
        return "table-danger";
      case "Reference":
        return "table-info";
      default:
        return "";
    }
  }

  const canManage = parseInt(userRole, 10) !== 4;

  const btnStyle = {
    background: 'linear-gradient(135deg, #344767 0%, #21243d 100%)',
    border: 'none', borderRadius: '9px', padding: '9px 18px',
    color: '#fff', fontWeight: '600', fontSize: '13px', cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: '7px',
    boxShadow: '0 4px 12px rgba(52,71,103,0.25)', whiteSpace: 'nowrap',
    transition: 'opacity 0.2s, transform 0.2s',
  };
  const btnOutlineStyle = {
    background: 'transparent',
    border: '1.5px solid #344767', borderRadius: '9px', padding: '8px 18px',
    color: '#344767', fontWeight: '600', fontSize: '13px', cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: '7px',
    whiteSpace: 'nowrap', transition: 'all 0.2s',
  };
  const selectStyle = {
    padding: '9px 14px', border: `1.5px solid ${isEmployeeSelectedError ? '#f5365c' : '#e9ecef'}`,
    borderRadius: '9px', fontSize: '13px', color: '#344767',
    background: '#fff', outline: 'none', minWidth: '220px', cursor: 'pointer',
  };

  return (
    <div>
      <Toast ref={toast} />
      <style>{`.leads-toolbar-btn:hover{opacity:.85;transform:translateY(-1px)} .leads-outline-btn:hover{background:#f4f6fb !important}`}</style>

      {canManage && (
        <div style={{
          display: 'flex', alignItems: 'center', flexWrap: 'wrap',
          gap: '10px', marginBottom: '16px',
          background: '#fff', borderRadius: '14px',
          padding: '14px 18px',
          boxShadow: '0 2px 12px rgba(52,71,103,0.07)',
        }}>
          {/* Left group: employee select + assign */}
          <select
            name="userId"
            id="userId"
            style={selectStyle}
            value={selectedValue}
            onChange={(e) => handleChange(e.target.value)}
          >
            <option value="" disabled>Assign lead(s) to employee…</option>
            {employees.map((employee) => (
              <option key={employee.id} value={employee.id}>
                {employee.firstName}
              </option>
            ))}
          </select>

          <button
            type="button"
            className="leads-toolbar-btn"
            style={btnStyle}
            onClick={() => AssignLead()}
          >
            <FaUserAlt size={12} /> Assign Leads
          </button>

          {isEmployeeSelectedError && (
            <span style={{ fontSize: '12px', color: '#f5365c', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <i className="fas fa-exclamation-circle" /> Select an employee
            </span>
          )}

          {selectedRows.size > 0 && (
            <span style={{
              background: '#e8f5e9', color: '#2dce89', borderRadius: '20px',
              padding: '4px 12px', fontSize: '12px', fontWeight: '700',
            }}>
              {selectedRows.size} selected
            </span>
          )}

          {/* Spacer */}
          <div style={{ flex: 1 }} />

          {/* Right group: import + add */}
          <button
            type="button"
            className="leads-outline-btn"
            style={btnOutlineStyle}
            onClick={() => navigate('/importLeads')}
          >
            <FaFileImport size={13} /> Import Leads
          </button>

          <button
            type="button"
            className="leads-toolbar-btn"
            style={btnStyle}
            onClick={() => navigate('/addlead')}
          >
            <FaPlus size={12} /> Add Lead
          </button>
        </div>
      )}

      <div className="col-12">
        <div className="list-card my-2">
          <div className="list-card-header">
            <div className="list-card-title">
              <span className="list-card-icon">
                <FaUsers />
              </span>
              <div>
                <h5>Leads</h5>
                <p>All captured leads with assignment & source details</p>
              </div>
            </div>
            <div className="list-card-actions">
              {selectedRows.size > 0 && (
                <span className="list-count-pill">
                  {selectedRows.size} selected
                </span>
              )}
            </div>
          </div>
          <div className="card-body px-0 pb-2 pt-0">
            <div className="table-responsive p-0">
              <table
                className="table align-items-center mb-0"
                id="tableData"
                ref={tableRef}
              >
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Lead Code</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Address</th>
                    <th>Property</th>
                    <th className="text-center">Source</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Leads;
